export default "__VITE_ASSET__DEO2b8hw__"